<template>
  <div class="cart-items">
    <p class="cart-title">
      <span v-if="currentStep === 0">{{ Translator('front.cart.items.title') }}</span>
      <span v-if="currentStep === 1">{{ Translator('front.cart.checkout.title') }}</span>
    </p>
    <div class="cart-loader" v-if="items === null"></div>
    <div class="cart-items-wrapper" v-if="items">
      <div class="cart-items-container" v-if="items.length > 0">
        <div class="cart-items-list">
          <div v-for="item in items" :key="item.id">
            <cart-item v-if="!item.variant.product.cannotBeSoldIndividually" v-bind:datas="item"/>
          </div>
          <div v-if="freeVariantItem" class="cart-items-free">
            <p class="cart-items-free-title">{{ Translator('front.cart.free.item') }}</p>
            <p class="cart-items-free-title">{{ freeVariantItem.variant.name }}</p>
          </div>
        </div>
      </div>
      <div class="cart-emtpy" v-else>
        <p class="cart-emtpy-content">{{ Translator('front.cart.items.empty') }}</p>
      </div>
    </div>

    <div class="cart-items-promo" v-if="order && order.promotionCoupon && order.promotionCoupon.promotion">
      <p class="cart-resume-promo-title">{{ Translator('front.cart.promo.title') }}</p>
      <div class="cart-resume-promo-row">
        <p class="cart-resume-promo-label">{{ order.promotionCoupon.promotion.name }}</p>
        <p class="cart-resume-promo-value">
          <span class="cart-resume-promo-price">{{ (order.orderPromotionTotal * config.currency.rate / 100) | toFixed(2) }} {{ config.currency.symbol }}</span>
          <button type="button" class="cart-resume-ico-button" @click="onRemovePromotion" v-if="currentStep === 0">
            <i class="ico ico-cross"></i>
            <span class="hide-access">{{ Translator('front.cart.promo.remove') }}</span>
          </button>
        </p>
      </div>
    </div>
    <form class="cart-items-promo" @submit="onSubmitPromo"
      v-else-if="order && items && items.length > 0 && currentStep === 0">
      <div class="cart-items-input form-group">
        <label for="promotion-cart">{{ Translator('front.cart.promo.label') }}</label>
        <input type="text" id="promotion-cart" autocomplete="off" name="promotion" v-model="form.promoCode"
          @focus="onFocus" @blur="onBlur">
      </div>
      <button type="submit" class="cart-button" :disabled="isPromoSubmited" :class="{'is-loading': isPromoSubmited}">{{
        Translator('front.cart.promo.apply') }}</button>
    </form>

    <div v-if="currentStep === 0 && items && items.length > 0" class="std-form">
      <div class="cart-loader" v-if="!freeVariants"></div>
      <div class="cart-free" v-else-if="freeVariants && freeVariants.length > 0">
        <button type="button" class="cart-free-toggle" :class="{'is-open': isFreeOpen, 'is-alert': hasAlertFree}" @click="isFreeOpen = !isFreeOpen">
          {{ Translator('front.cart.free.toggle') }}
          <i class="ico ico-more" v-if="!isFreeOpen"></i>
          <i class="ico ico-minus" v-if="isFreeOpen"></i>
        </button>
        <div class="cart-free-wrapper" v-if="isFreeOpen">
          <div class="radio" v-for="variant in freeVariants" :key="variant.id">
            <label>
              <input :disabled="isFreeSubmited" type="radio" v-model="form.freeVariant" :value="variant['@id']" @change="onChangeFreeVariant">
              {{ variant.name }}
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="cart-items-total" v-if="order && items && items.length > 0">
      <p class="cart-items-total-label">{{ Translator('front.cart.items.subtotal') }}</p>
      <p class="cart-items-total-value">{{ (order.totalItemsPriceTtc * config.currency.rate/100)|toFixed(2) }} {{ config.currency.symbol }}</p>
    </div>
    <div class="cart-items-total" v-if="order && items && items.length > 0 && order.promotions && order.promotions.length > 0">
      <p class="cart-items-total-label">{{ Translator('front.cart.items.promotions') }} {{ (order.orderPromotionTotal / 100)|toFixed(2) }} {{ config.currency.symbol }}</p>
      <p class="cart-items-total-value" v-for="promotion in order.promotions" :key="promotion.id">{{ promotion.name }}</p>
    </div>
    <div class="cart-items-total" v-if="order && items && items.length > 0 && order.shippingMethod">
      <p class="cart-items-total-label">{{ Translator('front.cart.items.delivery') }}</p>
      <p class="cart-items-total-value" v-if="order.shippingTotal === 0">{{ Translator('front.cart.delivery.free') }}</p>
      <p class="cart-items-total-value" v-if="order.shippingTotal > 0">{{ (order.shippingTotal * config.currency.rate/100)|toFixed(2) }} {{ config.currency.symbol }}</p>
    </div>
    <div class="cart-items-total" v-if="order && items && items.length > 0">
      <p class="cart-items-total-label">{{ Translator('front.cart.items.total') }}</p>
      <p class="cart-items-total-value">{{ (order.totalTtc * config.currency.rate/100)|toFixed(2) }} {{ config.currency.symbol }}</p>
    </div>
    <p class="cart-items-vat" v-if="order && items && items.length > 0">{{ Translator('front.product.vat') }}</p>
    <button type="button" @click="onGoCheckout" class="cart-button" v-if="order && items && items.length > 0 && (currentStep === 0 )"
      :disabled="isPromoSubmited || isFreeSubmited || isSaving || (order && order.items && order.items.length === 0)" :class="{'is-loading': isSaving || isPromoSubmited || isFreeSubmited}">
      <span>{{ Translator('front.cart.items.checkout') }}</span>
    </button>
  </div>
</template>
<style scoped lang="scss">
  .cart-items {
    margin-right: 0;
    margin-left: auto;
    padding: rem(20);
    width: 100%;
    margin-bottom: rem(30);
    @include tablet {
      padding: rem(40);
      width: 40%;
    }
    @include desktop {
      width: 30%;
    }
    @include desktop-xl {
      width: 25%;
    }
    @include desktop-xxl {
      width: 20%;
    }
    .cart-items-promo {
      margin-bottom: rem(40);
    }
    .cart-resume-promo-title {
      @include upper;
    }
    .cart-resume-promo-row {
      @include upper;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }
    .cart-resume-promo-value {
      display: flex;
      align-items: center;
    }
    .cart-resume-promo-price {
      @include upper;
    }
    .cart-resume-ico-button {
      @include resetBtn;
      width: rem(30);
      height: rem(30);
      vertical-align: middle;
      .ico {
        font-size: rem(18);
      }
    }
    .cart-items-input {
      position: relative;
      margin-bottom: rem(20);
      &.is-focus, &.is-not-empty {
        label {
          transform: translateY(#{rem(-20)});
        }
      }
      label {
        @include upper;
        color: $grey;
        position: absolute;
        top: 0;
        left: 0;
        transition: transform .2s;
        transform: translateY( #{rem(5)} );
      }
      input {
        @include form-input;
      }
    }
    .cart-items-total {
      position: relative;
      margin-bottom: rem(15);
    }
    .cart-items-total-label {
      @include upper;
    }
    .cart-items-total-value {
      @include upper;
    }
    .cart-items-vat {
      @include upper;
      margin-bottom: rem(30);
    }
    .cart-title {
      margin-bottom: rem(30);
    }
  }
  .std-form {
    margin-bottom: 0 !important;
  }
  .cart-items-free {
    margin-bottom: rem(30);
  }
  .cart-items-free-title {
    @include upper;
  }
  .cart-free {
    margin-bottom: rem(30);
  }
  .cart-free-wrapper {
    padding-top: rem(20);
  }
  .cart-free-toggle {
    @include link;
    position: relative;
    text-align: left;
    .ico {
      color: $black;
    }
    &.is-alert {
      color: $color-error;
    }
  }
  .cart-emtpy {
    @include upper;
  }
</style>
<script>
import AppControlService from '@/services/AppControl';
import ProductsService from '@/services/Products';
import UsersService from '@/services/Users';
import ModalService from '@/services/Modal';
import OrdersService from '@/services/Orders';
import CartItem from '@/components/CartItem';

export default {
  name: 'cart-items',
  components: {
    CartItem
  },
  data () {
    return {
      items: null,
      order: null,
      isSaving: false,
      isFreeSubmited: false,
      config: window.config,
      isConnected: UsersService.isConnected,
      currentStep: AppControlService.currentStep,
      previousSave: '',
      hasAlertFree: OrdersService.alertFree,
      isFreeOpen: false,
      isPromoSubmited: false,
      freeVariants: null,
      freeVariantItem: null,
      form: {
        promoCode: null,
        freeVariant: null
      }
    }
  },

  created() {
    this._onUpdateCart = this._onUpdateCart.bind(this);
    this._onLogged = this._onLogged.bind(this);
    this._onUpdateStep = this._onUpdateStep.bind(this);
    this._onAbortStep = this._onAbortStep.bind(this);
    this._onValidatingStep = this._onValidatingStep.bind(this);
    this._onUpdateFreeAlert = this._onUpdateFreeAlert.bind(this);
    AppControlService.on('aborted', this._onAbortStep);
    AppControlService.on('validating', this._onValidatingStep);
    AppControlService.on('step', this._onUpdateStep);
    OrdersService.on('updated', this._onUpdateCart);
    OrdersService.on('alertFree', this._onUpdateFreeAlert);
    UsersService.on('updated', this._onLogged);
    this._initCart();
  },

  beforeDestroy() {
    AppControlService.off('aborted', this._onAbortStep);
    AppControlService.off('validating', this._onValidatingStep);
    AppControlService.off('step', this._onUpdateStep);
    OrdersService.off('updated', this._onUpdateCart);
    OrdersService.off('alertFree', this._onUpdateFreeAlert);
    UsersService.off('updated', this._onLogged);
  },

  mounted() {},
  methods: {
    onConnect() {
      window.openLogin();
    },

    onChangeFreeVariant() {
      this.isFreeSubmited = true;
      this._checkAndDeleteFreeVariant().then( () => {
        OrdersService.addItem({
          variant: this.form.freeVariant,
          quantity: 1
        }).then( () => {
          OrdersService.get().then( () => {
            this.isFreeSubmited = false;
            this.isFreeOpen = false;
          })
        }).catch( () => {
          this.isFreeSubmited = false;
        });
      })
      OrdersService.alertFree = false;
    },

    _checkAndDeleteFreeVariant() {
      return new Promise( (resolve, reject) => {
        if(this.freeVariantItem) {
          OrdersService.deleteItem(this.freeVariantItem.id).then(resolve).catch(reject);
        } else resolve();
      });
    },

    onRemovePromotion() {
      this.form.promoCode = null;
      this.order.promotionCoupon = null;
      this.isPromoSubmited = true;
      OrdersService.promoUpdate().then().then(() => {
        this.isPromoSubmited = false;
      })
    },

    onFocus(pEvt) {
      pEvt.target.closest('.form-group').classList.add('is-focus');
    },

    onBlur(pEvt) {
      const el = pEvt.target;
      const group = el.closest('.form-group');
      group.classList.remove('is-focus');

      let isEmpty = true;
      if ((el.tagName === 'INPUT' || el.tagName === 'SELECT') && el.value !== '') isEmpty = false;
      else if (el.tagName === 'TEXTAREA' && el.value !== '') isEmpty = false;
      group.classList.toggle('is-not-empty', !isEmpty);
    },

    onSubmitPromo(pEvt) {
      pEvt.preventDefault();
      if (this.isPromoSubmited) return;
      this.isPromoSubmited = true;
      OrdersService.promoUpdate(this.form.promoCode).then().catch(err => {
        window.messageAlert.open(err.response.data.message ? err.response.data.message : err.response.data['hydra:description'] );
      }).then(() => {
        this.isPromoSubmited = false;
        this.form.promoCode = null;
        this.isSaving = false;
      })
    },

    onGoCheckout() {
      if (this.isSaving) return;
      if (!this.form.freeVariant && this.freeVariants?.length > 0) {
        ModalService.open();
        return;
      }
      AppControlService.validStep();
    },

    _onUpdateStep(step) {
      this.currentStep = step;
      setTimeout(() => {
        this.isSaving = false;
      });
    },

    _onLogged() {
      this.isConnected = UsersService.isConnected;
    },

    _onUpdateCart() {
      this._initCart();
      if( this.freeVariants === null ) {
        ProductsService.getAll({cannotBeSoldIndividually: true}).then( res => {
          const products = res.data['hydra:member'];
          if( products && products.length > 0 ) {
            let variants = [];
            products.forEach( product => {
              variants = [
                ...variants,
                ...product.variants
              ];
            })
            this.freeVariants = variants;
          }
        }).catch(console.error);
      }
    },

    _onAbortStep() {
      this.isSaving = false;
    },

    _onUpdateFreeAlert(pEvt) {
      this.hasAlertFree = pEvt;
      if( this.hasAlertFree ) this.isFreeOpen = true;
    },

    _onValidatingStep() {
      this.isSaving = true;
    },

    _initCart() {
      if(OrdersService.cart) {
        this.order = OrdersService.cart;
        this.items = OrdersService.cart.items;
        this.form.freeVariant = null;
        this.freeVariantItem = null;
        this.items.forEach( item => {
          if(item.variant.product.cannotBeSoldIndividually) {
            this.form.freeVariant = item.variant['@id'];
            this.freeVariantItem = item;
          }
        })
      } else this.items = null;
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },
  }
};
</script>
